import { RjsfDescriptionLink } from './RjsfDescriptionLink'
import { FC } from 'react'
import { useFeature } from '../../../store/features'

const DOCS_LINK = 'https://docs.feedyou.ai/books/api/page/podklady-pro-vytvoreni-integracniho-kroku'

export const WithModelSpecificPropertyWarning: FC = ({ children }) => {
  const isEnabled = useFeature('LLM_MODEL_SETTINGS_DOCS_LINK')

  if (!isEnabled) {
    return <>{children}</>
  }

  return (
    <>
      {children}
      <br />
      <br />
      This setting is only applicable for certain LLM models.{' '}
      <RjsfDescriptionLink href={DOCS_LINK} text="See documentation" /> for detailed information.
    </>
  )
}
